import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Persentase Tertimbang";
const DESCRIPTION =
  "Kalkulator persentase tertimbang yang akurat: hitung nilai tertimbang Anda untuk penerimaan universitas berdasarkan IPK, nilai kemampuan, dan nilai pencapaian! Alat yang diakui oleh lembaga pendidikan dengan penjelasan langkah demi langkah tentang cara menghitung persentase tertimbang.";
const KEYWORDS = "hitung, persentase tertimbang, IPK, kemampuan, pencapaian";
const OG_URL =
  "https://do-calculate.com/calculator/id/weighted-percentage-calculator/";
function WeightedPercentageCalculator() {
  const [secondaryGrade, setSecondaryGrade] = useState();
  const [aptitudeScore, setAptitudeScore] = useState();
  const [achievementScore, setAchievementScore] = useState();
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      let weightedPercentage = 0;
      if (secondaryGrade && aptitudeScore && achievementScore) {
        weightedPercentage =
          secondaryGrade * 0.3 + aptitudeScore * 0.3 + achievementScore * 0.4;
      } else if (secondaryGrade && aptitudeScore) {
        weightedPercentage = secondaryGrade * 0.6 + aptitudeScore * 0.4;
      }
      setResult(weightedPercentage.toFixed(2));
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Kalkulator ini menghitung persentase tertimbang berdasarkan:</p>
                <ul>
                  <li>IPK SMA</li>
                  <li>Nilai Kemampuan</li>
                  <li>Nilai Pencapaian (jika ada)</li>
                </ul>
                <p>Rumus berikut digunakan untuk menghitung persentase tertimbang:</p>
                <ul>
                  <li>
                    (IPK SMA × 30%) + (Nilai Kemampuan × 30%) + (Nilai Pencapaian × 40%)
                  </li>
                  <li>
                    (IPK SMA × 50%) + (Nilai Kemampuan × 20%) + (Nilai Pencapaian × 30%)
                  </li>
                  <li>
                    (IPK SMA × 60%) + (Nilai Kemampuan × 40%)
                  </li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div
                      className="form-group"
                      htmlFor="secondaryGrade"
                    >
                      <label className="form-label ms-2">
                        IPK SMA
                      </label>
                      <input
                        id="secondaryGrade"
                        type="number"
                        value={secondaryGrade}
                        onChange={(e) => setSecondaryGrade(e.target.value)}
                        placeholder="Masukkan IPK"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div
                      className="form-group"
                      htmlFor="aptitudeScore"
                    >
                      <label className="form-label ms-2">Nilai Kemampuan</label>
                      <input
                        id="aptitudeScore"
                        type="number"
                        value={aptitudeScore}
                        onChange={(e) => setAptitudeScore(e.target.value)}
                        placeholder="Masukkan nilai kemampuan"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div
                      className="form-group"
                      htmlFor="achievementScore"
                    >
                      <label className="form-label ms-2">
                        Nilai Pencapaian (Opsional)
                      </label>
                      <input
                        id="achievementScore"
                        type="number"
                        value={achievementScore}
                        onChange={(e) => setAchievementScore(e.target.value)}
                        placeholder="Masukkan nilai pencapaian"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Kesalahan: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p className="text-white">{result}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Detail Persentase Tertimbang</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Cara Menghitung Persentase Tertimbang
                    </h2>{" "}
                  </u>
                  <p>
                    Persentase tertimbang dihitung menggunakan salah satu rumus berikut berdasarkan persyaratan:
                  </p>
                  <ul>
                    <li>
                      (IPK SMA × 30%) + (Nilai Kemampuan × 30%) + (Nilai Pencapaian × 40%)
                    </li>
                    <li>
                      (IPK SMA × 50%) + (Nilai Kemampuan × 20%) + (Nilai Pencapaian × 30%)
                    </li>
                    <li>
                      (IPK SMA × 60%) + (Nilai Kemampuan × 40%)
                    </li>
                  </ul>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pentingnya Persentase Tertimbang</h2>{" "}
                  </u>
                  <p>
                    Persentase tertimbang dianggap sebagai salah satu kriteria terpenting yang digunakan untuk penerimaan universitas, dan persentase tertimbang bervariasi dari satu universitas ke universitas lainnya.
                  </p>
                  <ul>
                    <li>Menentukan kesiapan siswa untuk program akademik yang berbeda.</li>
                    <li>Meningkatkan peluang penerimaan dalam spesialisasi yang diinginkan.</li>
                  </ul>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum (FAQ)</h2>{" "}
                  </u>
                  <p>
                    Di sini Anda dapat menemukan jawaban atas pertanyaan paling umum tentang menghitung persentase tertimbang:
                  </p>
                  <ul>
                    <li>Apa itu IPK SMA?</li>
                    <li>Bagaimana nilai kemampuan dan pencapaian mempengaruhi persentase tertimbang?</li>
                    <li>Apa yang harus saya lakukan jika saya tidak memiliki nilai pencapaian?</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WeightedPercentageCalculator;